// SEO CONFIG
export const META_TITLE_SUFFIX = ' | NSFW.app'

export const DEFAULT_META_TITLE = `NSFW+ | For creators and fans`

export const DEFAULT_META_DESC = `NSFW+ is an Decentralised Autonomous Organisation that provides a creator marketplace where fans can interact in a safe and secure environment using modern web3 primitives. The platform is designed to nurture new and engaging experiences for creators and fans alike.`

// PAGE CACHE CONTROLS
export const PROFILE_MAX_AGE_SEC = process.env.PROFILE_MAX_AGE_SECONDS ?? '10'
export const PROFILE_STALE_WHILE_REVALIDATE_SEC =
  process.env.PROFILE_STALE_WHILE_REVALIDATE_SEC ?? '59'

export const POST_MAX_AGE_SEC = process.env.POST_MAX_AGE_SECONDS ?? '10'
export const POST_STALE_WHILE_REVALIDATE_SEC =
  process.env.POST_STALE_WHILE_REVALIDATE_SEC ?? '59'
